<template>
  <footer :class="{ 'mobile': isMobile, 'desktop': !isMobile }">
    <div class="container">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/images/Logo.svg" alt="menoah" />
        </router-link>
      </div>
      <nav>
        <router-link to="/terms">利用規約</router-link>
        <router-link to="/privacy-policy">プライバシーポリシー</router-link>
        <router-link to="/legal">特定商取引法に基づく表記</router-link>
        <router-link to="/company">会社概要</router-link>
      </nav>
      <p class="copyright">© {{ currentYear }} menoah, Inc. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  data() {
    return {
      isMobile: false,
      currentYear: new Date().getFullYear()
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768
    }
  }
}
</script>

<style scoped>
/* 共通スタイル - フッター全体の基本設定 */
footer {
  width: 100vw;
  max-width: 100%;
  background-color: var(--color-green-200);
  margin: 0;
  box-sizing: border-box;
  position: relative;
  left: 0;
  right: 0;
}

/* 共通スタイル - コンテナの配置と幅設定 */
.container {
  max-width: 1120px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

/* 共通スタイル - ナビゲーションリンク領域 */
nav {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 40px;
}

/* 共通スタイル - ナビゲーションリンクのテキスト設定 */
nav a {
  color: var(--color-grey-500);
  text-decoration: none;
  font-size: 16px;
  margin-bottom: 10px;
}

/* 共通スタイル - コピーライトテキスト設定 */
.copyright {
  font-size: 14px;
  color: var(--color-grey-500);
  margin-bottom: 48px;
}

/* モバイル専用スタイル - isMobileがtrueの場合に適用 */
footer.mobile {
  padding: 32px 34px;
}

.mobile .container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

/* モバイル専用スタイル - ロゴエリアの設定 */
.mobile .logo {
  margin-bottom: 32px;
  margin-top: 24px;
}

/* モバイル専用スタイル - ロゴ画像のサイズ */
.mobile .logo img {
  height: 24px;
}

/* モバイル専用スタイル - ナビゲーションの縦並び設定 */
.mobile nav {
  flex-direction: column;
  align-items: flex-start;
}

/* モバイル専用スタイル - ナビゲーションリンクの間隔設定 */
.mobile nav a {
  margin-bottom: 14px;
}

/* デスクトップ専用スタイル - isMobileがfalseの場合に適用 */
footer.desktop {
  padding: 40px 0px;
}

.desktop .container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

/* デスクトップ専用スタイル - ロゴエリアの設定 */
.desktop .logo {
  margin-bottom: 36px;
  margin-top: 36px;
}

/* デスクトップ専用スタイル - ロゴ画像のサイズ */
.desktop .logo img {
  height: 28px;
}

/* デスクトップ専用スタイル - ナビゲーションの配置設定 */
.desktop nav {
  flex-direction: column;
  align-items: flex-start;
}

/* デスクトップ専用スタイル - ナビゲーションリンクの間隔設定 */
.desktop nav a {
  margin-right: 0;
  margin-bottom: 14px;
}

/* デスクトップ専用スタイル - ホバー時の下線表示 */
.desktop nav a:hover {
  text-decoration: underline;
}
</style>
